import { render, staticRenderFns } from "./chongzhi_config.vue?vue&type=template&id=8ee94a3e&scoped=true"
import script from "./chongzhi_config.vue?vue&type=script&lang=js"
export * from "./chongzhi_config.vue?vue&type=script&lang=js"
import style0 from "./chongzhi_config.vue?vue&type=style&index=0&id=8ee94a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee94a3e",
  null
  
)

export default component.exports